/* eslint-disable */
// initial state
// shape: [{ id, quantity }]
const state = {
  set nickNameStatus(val) {
    sessionStorage.setItem('nickNameStatus', val)
  },
  get nickNameStatus() {
    sessionStorage.getItem('nickNameStatus')
  },
  set highCerStatus(val) {
    sessionStorage.setItem('highCerStatus', val)
  },
  get highCerStatus() {
    sessionStorage.getItem('highCerStatus')
  },
  isIndex: false,
  sessionStr: '',
  sessionUserId: '',
  userInfo: {},
  myInviteCode: '',
  isPurchase: false, // 是否展示预购活动
  myUrl: '/login',
  setReg: '',
  regUrl: '/register',
  currencyDetail: {
    commodityId: 0,
    commodityCode: '0',
    baseCurrency: '',
    quotedCurrency: '',
    commodityName: '',
    commodityStatus: 1,
    priceScale: 1,
    quantityScale: 1,
    guidePrice: 1,
    stopLossPoint: 1,
    takeProfitPoint: 1,
    limitOpenPoint: 1,
    defaultMarketOrderPoint: 1,
    quoteSrc: '',
    unitConversionRate: 1,
    exchangeRate: null,
    quoteAgio: null,
    timeoutSeconds: 1,
    quotePointAlgr: 2,
    quotePointRate: 1,
    quotePoint: null,
    protectPause: null,
    manualPause: null,
    specialTimePause: null,
    quantityStrategyId: 1,
    oneMaxOrderQuantity: 1,
    oneMinOrderQuantity: 1,
    maxNetHold: 1,
    marginStrategyId: 1,
    marginAlgr: 1,
    marginRate: 1,
    feeStrategyId: 1,
    feeAlgr: 1,
    openTradeFeeRate: 0.001,
    closeTradeFeeRate: 0.001,
    tradeNumeral: 1,
    tradeMeasure: '',
    demurrageStrategyId: 80,
    demurrageAlgr: 1,
    demurrageRate: 0.01,
    newCommodityStatus: '已上市',
    newQuotePointAlgr: '固定值',
    newMarginAlgr: '比例',
    newFeeAlgr: '固定值'
  },
  commodityInformationData: {},
  bottomLinkNavKeyData: '',
  totalAssetsData: '',
  riskNoteCookie: '',
  currencyDetailMid: {},
  commodityInformationDataMid: {},
  riskNoteCookieMid: '',
  set sessionVip(val) {
    localStorage.setItem('isVip', val)
  },
  get sessionVip() {
    return localStorage.getItem('isVip')
  }, set sessionVipDate(val) {
    localStorage.setItem('vipDate', val)
  },
  get sessionVipDate() {
    return localStorage.getItem('vipDate')
  },
  set sessionInfo(val) {
    if (val === '') {
      sessionStorage.clear()
      return
    }
    const {
      isLogin,
      userId,
      sessionStr,
      tel,
      firmId,
      firmCode
    } = val
    sessionStorage.setItem('isLogin', isLogin)
    sessionStorage.setItem('userId', userId)
    sessionStorage.setItem('sessionStr', sessionStr)
    sessionStorage.setItem('tel', tel)
    sessionStorage.setItem('firmId', firmId)
    sessionStorage.setItem('firmCode', firmCode)
  },
  get sessionInfo() {
    const sessionInfo = {}
    if (!sessionStorage.getItem('isLogin')) {
      sessionStorage.setItem('isLogin', false)
    }
    sessionInfo.isLogin = sessionStorage.getItem('isLogin')?sessionStorage.getItem('isLogin'):false
    sessionInfo.userId = sessionStorage.getItem('userId')?sessionStorage.getItem('userId'):0
    sessionInfo.sessionStr = sessionStorage.getItem('sessionStr')?sessionStorage.getItem('sessionStr'):0
    sessionInfo.tel = sessionStorage.getItem('tel')?sessionStorage.getItem('tel'):0
    sessionInfo.firmId = sessionStorage.getItem('firmId')?sessionStorage.getItem('firmId'):0
    sessionInfo.firmCode = sessionStorage.getItem('firmCode')?sessionStorage.getItem('firmCode'):0
    sessionInfo.userType = sessionStorage.getItem('userType')?sessionStorage.getItem('userType'):'T'
    return sessionInfo
  },
  set userCerStatus(val) {
    sessionStorage.setItem('userCerStatus', val)
  },
  get userCerStatus() {
    return sessionStorage.getItem('userCerStatus')
  },
  // 我的资金 from getMyAccount
  myassetData: {
    accountId: null,
    avilibleMargin: 0,
    balance: 0,
    buyFunds: 0,
    canBeMargin: 0,
    canOutMoney: 0,
    closePl: 0,
    createTime: 0,
    deliveryClosePl: 0,
    deliveryFee: 0,
    deliveryMargin: 0,
    firmId: 0,
    floatPl: 0,
    frozenFunds: 0,
    holdFloatPl: 0,
    inGold: 0,
    lastBalance: 0,
    lastDeliveryMargin: 0,
    lastHoldMargin: 0,
    lastHoldPl: 0,
    lastOweMoney: 0,
    lastRight: 0,
    marketId: 3,
    marketInGold: 0,
    marketOutGold: 0,
    occupyMargin: 0,
    orderHoldMargin: 0,
    outGold: 0,
    oweMoney: 0,
    procedureFee: 0,
    profit: 0,
    right: null,
    risk: 0,
    sellFunds: 0,
    stampFee: 0,
    swapsFee: 0,
    symbolId: null,
    transferClosePl: 0,
    updateTime: 0,
    wyFunds: 0,
  },
  // 融合资金
  userAsset: {
    accountId: null,
    avilibleMargin: 0,
    balance: 0,
    buyFunds: 0,
    canBeMargin: 0,
    canOutMoney: 0,
    closePl: 0,
    createTime: 0,
    deliveryClosePl: 0,
    deliveryFee: 0,
    deliveryMargin: 0,
    firmId: 0,
    floatPl: 0,
    frozenFunds: 0,
    holdFloatPl: 0,
    inGold: 0,
    lastBalance: 0,
    lastDeliveryMargin: 0,
    lastHoldMargin: 0,
    lastHoldPl: 0,
    lastOweMoney: 0,
    lastRight: 0,
    marketId: 3,
    marketInGold: 0,
    marketOutGold: 0,
    occupyMargin: 0,
    orderHoldMargin: 0,
    outGold: 0,
    oweMoney: 0,
    procedureFee: 0,
    profit: 0,
    right: null,
    risk: 0,
    sellFunds: 0,
    stampFee: 0,
    swapsFee: 0,
    symbolId: null,
    transferClosePl: 0,
    updateTime: 0,
    wyFunds: 0,
  },
  unReadNum: 0, // 未读消息条数
  unTime: '', // 最后一条的时间
  unReadMess: '', // 最后一条未读消息内容
  transferList: [], // 可划转商品
  serverTimeOffset: 0 // 服务器时间与本地时间的差值（服务器时间 - 本地时间）
}

// getters
const getters = {
  userAssetGetter: state => state.userAsset,
  highCerStatusGetter: (state) => state.highCerStatus,
  nickNameStatusGetter: (state) => state.nickNameStatus,
  isIndexGetter: (state) => state.isIndex,
  sessionInfoGetter: function(state) {
    return state.sessionInfo
  },
  userInfoGetter: (state) => state.userInfo,
  myInviteCodeGetter: (state) => state.myInviteCode,
  userCerStatusGetter: (state) => state.userCerStatus,
  currencyDetailGetter: (state) => state.currencyDetail,
  commodityInformationDataGetter: (state) => state.commodityInformationData,
  bottomLinkNavKeyGetter: (state) => state.bottomLinkNavKeyData,
  totalAssetsGetter: (state) => state.totalAssetsData,
  riskNoteCookieGetter: (state) => state.riskNoteCookie,
  currencyDetailMidGetter: (state) => state.currencyDetailMid,
  riskNoteCookieMidGetter: (state) => state.riskNoteCookieMid,
  setriskNoteCookieMid(state, value) {
    state.riskNoteCookieMid = value
  },
  commodityInformationDataMidGetter: (state) => state.commodityInformationDataMid,
  myassetDataGetter: (state) => state.myassetData,
  vipGetter: (state) => state.sessionVip,
  vipDateGetter: (state) => state.sessionVipDate,
  isPurchaseGetter: (state) => state.isPurchase,
  unReadNumGetter: (state) => state.unReadNum,
  unTimeGetter: (state) => state.unTime,
  unReadMessGetter: (state) => state.unReadMess,
  transferListGetter: (state) => state.transferList,
  serverTimeOffsetGetter: (state) => state.serverTimeOffset
}

// actions
const actions = {

}

// mutations
const mutations = {
  setUserAsset(state, data) {
    state.userAsset = data;
  },
  setIsPurchase(state, data) {
    state.isPurchase = data;
  },
  setHighCerStatus(state, value) {
    state.highCerStatus = value
  },
  setNickNameStatus(state, value) {
    state.nickNameStatus = value
  },
  changeIsIndex(state, value) {
    state.isIndex = value
  },
  setUserInfo(state, value) {
    state.userInfo = value
  },
  setMyViteCode(state, value) {
    state.myInviteCode = value
  },
  setSessionInfo: function(state, val) {
    state.sessionInfo = val
  },
  setUserCerStatus: function(state, val) {
    state.userCerStatus = val
  },
  setCurrencyDetail(state, value) {
    state.currencyDetail = value
  },
  setCommodityInformationData(state, value) {
    state.commodityInformationData = value
  },
  setBottomLinkNavKey(state, value) {
    state.bottomLinkNavKeyData = value
  },
  setTotalAssets(state, value) {
    state.totalAssetsData = value
  },
  setRiskNoteCookie(state, value) {
    state.riskNoteCookie = value
  },
  setCurrencyDetailMid(state, value) {
    state.currencyDetailMid = value
  },
  setcommodityInformationDataMid(state, value) {
    state.commodityInformationDataMid = value
  },
  setriskNoteCookieMid(state, value) {
    state.riskNoteCookieMid = value
  },
  setVip(state, value) { state.sessionVip = value },
  setVipDate(state, value) { state.sessionVipDate = value },
  setMyassetData(state, value) {
    state.myassetData = value
  },
  setUnReadNum(state, value) { state.unReadNum = value },
  setUnTime(state, value) { state.unTime = value },
  setUnReadMess(state, value) { state.unReadMess = value },
  settTransferList(state, value) { state.transferList = value },
  setServerTimeOffset(state, value) { state.serverTimeOffset = value }
}

export default {
  state,
  getters,
  actions,
  mutations
}
